import React, {PropsWithChildren} from 'react';

import InputLabel, {InputLabelProps} from '@material-ui/core/InputLabel';

import styles from './BootstrapLabel.module.css';


const BootstrapLabel = (props : PropsWithChildren<InputLabelProps>) => {

  return (
    <InputLabel
      classes={styles}
      {...props}
    >
      {props.children}
    </InputLabel>
  );
};

export default React.memo(BootstrapLabel);